export default __webpack_public_path__ + "static/media/error.80282ac4.jpg";